import { cn } from '@talentmesh/ui/lib/utils';

export interface StepItemProps {
    label: string;
    isFinished: boolean;
    isInteractive: boolean;
    hasLeftConnector: boolean;
    hasRightConnector: boolean;
    leftConnectorCompleted: boolean;
    rightConnectorCompleted: boolean;
    onClick?: () => void;
}

export function StepItem({
    label,
    isFinished,
    isInteractive,
    hasLeftConnector,
    hasRightConnector,
    leftConnectorCompleted,
    rightConnectorCompleted,
    onClick,
}: StepItemProps) {
    const content = (
        <>
            <span
                className={cn('text-center text-sm font-bold', isFinished ? 'text-primary' : 'text-muted-foreground')}
            >
                {label}
            </span>
            <div className="mt-1.5 flex w-full items-center">
                {hasLeftConnector ? (
                    <div className={cn('h-0.5 flex-1', leftConnectorCompleted ? 'bg-primary' : 'bg-muted')} />
                ) : (
                    <div className="flex-1" />
                )}
                <div
                    className={cn(
                        'flex size-3.5 shrink-0 items-center justify-center rounded-full',
                        isFinished ? 'bg-primary' : 'bg-muted',
                    )}
                />
                {hasRightConnector ? (
                    <div className={cn('h-0.5 flex-1', rightConnectorCompleted ? 'bg-primary' : 'bg-muted')} />
                ) : (
                    <div className="flex-1" />
                )}
            </div>
        </>
    );

    if (isInteractive) {
        return (
            <button
                type="button"
                className="flex flex-1 cursor-pointer flex-col items-center bg-transparent p-0"
                onClick={onClick}
            >
                {content}
            </button>
        );
    }

    return <div className="flex flex-1 flex-col items-center">{content}</div>;
}
